// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:36:17

export default {
  "id": "unblock-ball-slide-puzzle",
  "slug": "unblock-ball-slide-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/61146fa9777849418bf094c9ca7aa75b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/61146fa9777849418bf094c9ca7aa75b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Unblock Ball Slide Puzzle",
      "description": "Welcome to Unblock Ball: Slide Puzzle, a classic sliding puzzle game that lets you use your mind.You can feel a sense of accomplishment! Sliding the board to create the channel for the ball to roll smoothly to the end. You should use your logical mind to cleverly move blocks, avoid\nobstacles, and solve every puzzle!",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "avoid",
        "block",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "解锁球滑块拼图",
      "description": "欢迎来到《解锁球：滑动拼图》，一款经典的滑动拼图游戏，让你运用智慧。你可以感受到成就感！滑动板面，为球创造顺畅滚动的通道。你应该运用你的逻辑思维巧妙地移动方块，避开障碍，解决每一个谜题！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "谜题"
      ],
      "tags": [
        "避开",
        "阻挡",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "解鎖球滑動拼圖",
      "description": "歡迎來到《無阻礙球：滑動拼圖》，一款經典的滑動拼圖遊戲，讓你運用智慧。你可以感受到成就感！將板子滑動以為球創造一條順暢的通道，使其平滑地滾到終點。你應該運用你的邏輯思維巧妙地移動塊狀物，避開障礙，解決每一個謎題！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "避免",
        "阻擋",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "解鎖玻璃球滑動謎題",
      "description": "歡迎來到《無阻礙球：滑動拼圖》，一款經典的滑動拼圖遊戲，讓你運用腦力。你可以感受到成就感！滑動遊戲板，為球創造一條順暢的通道，使其輕鬆滾到終點。你應該運用邏輯思維，巧妙地移動塊體，避開障礙，解開每一個謎題！",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "謎題"
      ],
      "tags": [
        "避免",
        "封鎖",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "アンブロックボールスライドパズル",
      "description": "ウエルカム・トゥ・アンブローク・ボール：スライド・パズルへ！心を使って遊べるクラスicsなスライディング・パズルゲームです。達成感を感じられるでしょう！ボードをスライドさせて、ボールがスムーズに終わりまで転がれる道を作りましょう。論理的な頭を使って、ブロックを賢く動かし、障害物を避け、全てのパズルを解決しましょう！",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "避ける",
        "ブロック",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "얼록Ball 슬라이드 패ズل",
      "description": "웰컴 투 언블록 볼: 슬라이딩 퍼즐, 인지력을 사용할 수 있는 클래식 슬라이딩 퍼즐 게임입니다. 성취감을 느낄 수 있습니다! 보드를 드래그하여 볼이 무뎌지지 않게 끝까지 이동할 수 있는 길을 만들어주세요. 블록을 정리하며 장애물을 피하고 모든 퍼즐을 해결하는 데 논리적 사고를 사용해야 합니다!",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "회피",
        "차단",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Déblocage du Puzzle de Glisse de la Balle",
      "description": "Bienvenue dans Unblock Ball: Slide Puzzle, un jeu classique de puzzle de glissement qui vous permet d'utiliser votre esprit. Vous pouvez ressentir un sentiment d'accomplissement ! Glissez le plateau pour créer un canal permettant à la balle de rouler en douceur jusqu'à la fin. Vous devez utiliser votre esprit logique pour déplacer astucieusement les blocs, éviter les obstacles et résoudre chaque puzzle !",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "éviter",
        "bloquer",
        "puzzle glissant"
      ]
    }
  }
};
